import { render, staticRenderFns } from "./Premium.vue?vue&type=template&id=7068b44a&scoped=true&"
import script from "./Premium.vue?vue&type=script&lang=js&"
export * from "./Premium.vue?vue&type=script&lang=js&"
import style0 from "./Premium.vue?vue&type=style&index=0&id=7068b44a&prod&lang=scss&scoped=true&"
import style1 from "./Premium.vue?vue&type=style&index=1&id=7068b44a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7068b44a",
  null
  
)

export default component.exports